import type { HeadCasingSettings, HeadCasingNone, HeadCasingSlices } from "building-types/settings/headCasingSettings";
import { HeadCasingType } from "building-types/settings/settingsTypesEnum";

export function isHeadCasingNone(settings: HeadCasingSettings): settings is HeadCasingNone {
  return settings.headCasingType === HeadCasingType.NONE;
}

export function isHeadCasingSlices(settings: HeadCasingSettings): settings is HeadCasingSlices {
  return settings.headCasingType === HeadCasingType.SLICES;
}
